import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { propertyModel } from '../modeller/propertyModel';
import { siteApi } from '../tjenester/siteApi';

export function usePropertyDetail() {
  const [searchParams] = useSearchParams();
  const { propertySlug } = useParams();
  const [property, setProperty] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const returnTo = searchParams.get('returnTo') || '/#eiendommer';

  useEffect(() => {
    let isMounted = true;

    siteApi
      .getPropertyBySlug(propertySlug)
      .then((data) => {
        if (!isMounted) {
          return;
        }

        setProperty(propertyModel.mapWithSlug(data));
        setError('');
      })
      .catch((requestError) => {
        if (!isMounted) {
          return;
        }

        setError(requestError.message);
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [propertySlug]);

  return {
    error,
    isLoading,
    mapEmbedUrl: property ? propertyModel.createGoogleMapsEmbedUrl(property) : '',
    mapLinkUrl: property ? propertyModel.createGoogleMapsLink(property) : '',
    property,
    returnTo,
  };
}